import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';
import { cloneFilterState } from './data-filter.service';
import { applyFilterDateRange, buildFilterDateRange } from '../shared/date-filter.util';

@Injectable({
  providedIn: 'root'
})
export class WasteModuleService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);

  selectedConfiguration:any = {};
  startDate:Date = new Date();
  endDate:Date = new Date();


  getWasteModuleData() {
    return this.http.get(environment.apiUrl + 'recon_assay')
  }

  getIndvActComments(key: any, adminId: any, maapKey: any) {
    return this.http.get(environment.apiUrl + 'discrepancy_status?key=' + key+'&adminId='+adminId+'&maapKey='+maapKey);
  }

  setStartEndDates(filter: any){
    if(filter.duration)
    {
      const days = parseInt(filter.duration);
      this.startDate = new Date(+new Date() - days * 24 * 60 * 60 * 1000);
    }
    if(filter.startDate && filter.endDate){
      this.startDate = filter.startDate
      this.endDate = filter.endDate
    }
  }

  getOverideData(skip: any, filter: any) {
    filter = cloneFilterState(filter || {});
    if(filter['regionId'] == 'All'){
      delete filter.regionId;
    }
    if(filter['campusId'] == 'All'){
      delete filter.campusId;
    }
    if(filter['facilityId'] == 'All') {
      delete filter.facilityId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl + 'fetch/overriderules?$sort=-createdAt&$skip=' + skip + '&$limit=10&'+filterString)
  }

  getAdcData(maapKey: any, uniqueKey2: any, facilityId: any) {
    return this.http.get(environment.apiUrl + 'fetch/adc_ehr?RecordType=ADC&maapKey=' + maapKey + '&uniqueKey2=' + uniqueKey2 + "&facilityId=" + facilityId);
  }

  updateReconciliation(recieved: any, waste: any, id: any, practiceIssue: any, key: any, comment: any, taggedUsers: any, lanId: any, adminGroup: any, employeeName: any, location: any, medDesc: any) {
    const data ={
      'comment': comment,
      'practiceIssue': practiceIssue,
      'discrepancy': id,
      'key':key,
      'witnesstoken': this.authService.getWitnessToken(),
      'taggedUsers':taggedUsers,
      'lanId':lanId,
      'adminGroup':adminGroup,
      'employeeName':employeeName,
      'location':location,
      'medDesc':medDesc
    };
    (data as any)["notRecieved"] = recieved;
    if (waste!=null)
      (data as any)["wasteAmountRecieved"] = waste;
    if (practiceIssue)
      data["practiceIssue"] = practiceIssue;  
    return this.http.put(environment.apiUrl + 'update/recon/' + id, data);
  }

  updateAssay(data: any) {
    return this.http.put(environment.apiUrl + 'update/assay/' + data["id"]
      , {
        "notPerformed": data["notPerformed"],
        "_1stAssayResults": data["_1stAssayResults"],
        "_2ndAssayResults": data["_2ndAssayResults"],
        "_3rdAssayResults": data["_3rdAssayResults"],
        "_HPLCAssayResults": data["_HPLCAssayResults"] == "" ? 0 : data["_HPLCAssayResults"],
        "_PendingHPLCResults": data["_PendingHPLCResults"],
        "_PendingLabResults": data["_PendingLabResults"],
        "_InSource": data["_InSource"],
        "_OutSource": data["_OutSource"],
        "_Commercial": data["_Commercial"],
        "_HQI": data["_HQI"],
        "_AssayRiskScore": data["_AssayRiskScore"],
        "practiceIssue": data["practiceIssue"],
        'witnesstoken': this.authService.getWitnessToken(),
        'key': data["key"],
        'comment': data["comment"],       
        '_Pass': data["_Pass"],
        '_Fail': data["_Fail"],
        '_failOption': data["_failOption"],
        'discrepancy': data['id'],
        'taggedUsers':data['taggedUsers'],
        'lanId':data['lanId'],
        'adminGroup':data['adminGroup'],
        'employeeName':data['employeeName'],
        'location':data['loc'],
        'medDesc':data['medDesc']
      });
  }

  createOvrride(data: any) {
    data["witnesstoken"] = this.authService.getWitnessToken()
    return this.http.post(environment.apiUrl + "add/override", data)
  }

  submitFoundMedication(data: any) {
    data['witnesstoken'] = this.authService.getWitnessToken();
    return this.http.post(environment.apiUrl + 'add/found/medication', data);
  }

  getComments(id: any) {
    return this.http.get(environment.apiUrl + 'wm_comment?key=' + id);
  }

  submitComment(id: any, comment: any, resolution: any, practiceIssue: any, key: any, source: any, transType: any, taggedUsers: any, lanId: any, adminGroup: any, employeeName: any, location: any, patientId: any, date: any, medDesc: any, wasVerified: any) {
    return this.http.post(environment.apiUrl + 'wm/assay/comment', {
      'resolution': resolution,
      'comment': comment,
      'practiceIssue': practiceIssue,
      'discrepancy': id,
      'key':key,
      'witnesstoken': this.authService.getWitnessToken(),
      'transType':transType,
      'taggedUsers':taggedUsers,
      'lanId':lanId,
      'adminGroup':adminGroup,
      'employeeName':employeeName,
      'location':location,
      'patientId':patientId,
      'date':date,
      'medDesc':medDesc,
      'wasVerified':wasVerified
    })
  }

  fetchLocations() {
    return this.http.get(environment.apiUrl + 'fetch/locations');
  }

  fetchMeds() {
    return this.http.get(environment.apiUrl + 'fetch/meds');
  }

  updateOverrideRule(row: any) {
    const data = {};
    (data as any)["activeStatus"] = false;
    return this.http.post(environment.apiUrl + 'update/override',{id:row["_id"]});
  }

  fetchFilterOptions(filter: any = null) {
    filter = cloneFilterState(filter || {});
    let filterString = ""
    if(filter)
    if(filter['regionId'] == 'All'){
      delete filter.regionId;
    }
    if(filter['campusId'] == 'All'){
      delete filter.campusId;
    }
    if(filter['facilityId'] == 'All') {
      delete filter.facilityId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }
    filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl + 'filter/options?$isWasteModule=true&'+filterString);
  }

  fetchWasteEntryInformation(filter: any = null) {
    filter = cloneFilterState(filter || {});
    let filterString = ""
    if(filter)
    if(filter['regionId'] == 'All'){
      delete filter.regionId;
    }
    if(filter['campusId'] == 'All'){
      delete filter.campusId;
    }
    if(filter['facilityId'] == 'All') {
      delete filter.facilityId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }
    filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl + 'wasteentry/information?$'+filterString);
  }

  getAssayRequirementForSelectedMed() {
    const data = {};
    (data as any)["required"] = true;
  }

  getDiscrepancyPagedData(skip: any, limit: any, filter: any) {
    filter = cloneFilterState(filter || {});
    
    if(filter['regionId'] == 'All' || !(filter['regionId'])){
      delete filter.regionId;
    }
    if(filter['campusId'] == 'All' || !(filter['campusId'])){
      delete filter.campusId;
    }
    if(filter['facilityId'] == 'All' || !(filter['facilityId'])) {
      delete filter.facilityId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }
    const filterString = this.generateQueryStringFromObject(applyFilterDateRange(filter));
    this.setStartEndDates(filter);
    return this.http.get(environment.apiUrl + 'recon_assay?$skip=' + skip + '&$limit=10&' + filterString)
  }

  tryClearWhitespaceFromGlobalSearch(params: any)
  {
    if(params.globalSearch)
    {
      const textToTrim: string = params.globalSearch;
      params.globalSearch = textToTrim.trim();
    }
  }

  generateQueryStringFromObject(params: any){
    params = cloneFilterState(params || {});
    this.tryClearWhitespaceFromGlobalSearch(params);
    return Object.keys(params).map(key => key + '=' + params[key]).join('&');
  }


  getRetrievalLoggerIndex(skip: any, limit: any, filter: any) {
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl + 'get/retrieval/logs?$skip=' + skip + '&$limit='+limit+'&' + filterString)
  }

  createRetrievalLog(data: any) {
    data['witnesstoken'] = this.authService.getWitnessToken();
    return this.http.post(environment.apiUrl + 'create/retrieval/log', data);
  }

  getRetrievalLogData(id: any){
    return this.http.get(environment.apiUrl + 'get/retrievallog/data?id='+id)
  }
  getRetrievalLogHistory(id: any){
    return this.http.get(environment.apiUrl + 'get/retrievallog/history?facilityid='+id)
  }

  getOverideRawConfiguration(id: any){
    return this.http.get(environment.apiUrl + 'get/override/configuration/'+id)
  }

  saveRetrievalLogData(data: any){
    data['witnesstoken'] = this.authService.getWitnessToken();
    return this.http.post(environment.apiUrl + 'save/retrievallog/data', data);
  }

  requestRetrievalToken(data: any, facility: any){
    const obj = {user:this.authService.user.fullname, facility:facility, data:data};
    const objStr = JSON.stringify(obj);
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8')
    const res = this.http.post(environment.apiUrl+"request/post/token",objStr,{headers:headers});
    return res;
  }

  generateRetrievalLogsForPrint(retrievalLogs: any) {
    const data: any[] = []
    retrievalLogs.forEach( (item: any) => {
      data.push({ 
        device:item.device,
        expectedCounts:item.expectedCounts,
        actualCounts:item.actualCounts,
        startDate:item.startDate,
        endDate:item.endDate,
        wasteBin:item.wasteBin,
        comments:item.comments,
        bag:item.bag,
        recon:item.recon,
        time:item.time,
     });
    });
    return data;
  }

  /** Reset feature for WASTE: Reconciliation & Assay and updated on 19/10/2021 */
  resetReconciliation( id: any) {
    const data = {};
    (data as any)['witnesstoken'] = this.authService.getWitnessToken();
    return this.http.put(environment.apiUrl + 'reset/recon/' + id, data);
  }

  resetAssay( id: any) {
    const data = {};
    (data as any)['witnesstoken'] = this.authService.getWitnessToken();
    return this.http.put(environment.apiUrl + 'reset/assay/' + id, data);
  }
  /** Reset feature for WASTE: Reconciliation & Assay and updated on 19/10/2021 */

  searchAutoComplete(field: any, text: any, filter: any = null){
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl+'autocomplete/search?field='+field+'&text='+text+'&'+filterString)
  }
  public deleteOverrideRule(id: any) {
    return this.http.delete(environment.apiUrl+"delete/overrideRule/"+id)
  }
  submitMultipleresCode(discrepancies: any, resCode: any) {
    const witness = this.authService.getWitnessToken();
    
    discrepancies = discrepancies.map(function(record: any){
      return {"id":record.data.id, "key":record.data.lanId+record.data.medId+record.data.varDateString}
  })
    return this.http.post(environment.apiUrl + 'wm/multiple/resCode', {
      'discrepancy': discrepancies,
      'status': resCode,
      'witnesstoken': witness
    })
  }

  getActivityDiscrepancyData(skip: any, rowData: any, riskLevel: any)
  {
       const employeeName = rowData["employeeName"];
       const employeeId = rowData["employeeId"];
       const bedDev = rowData["bedDev"];
       const facilityId = rowData["facilityId"];

       const serviceGroup = rowData["serviceGroup"]
       const dateRange = buildFilterDateRange(rowData["transactionStartDate"], rowData["transactionEndDate"]);
       const transactionStartDate = dateRange ? dateRange.startIso : rowData["transactionStartDate"];
       const transactionEndDate = dateRange ? dateRange.endExclusiveIso : rowData["transactionEndDate"];
       const patientName = rowData["patientName"];
       const mrnNum = rowData["mrnNum"];
       const csn = rowData['csn']
       const medDesc = rowData["medDesc"];
       const medGroup = rowData['medGroup']

       const regionId = rowData['regionId']
       const campusId = rowData['campusId']
       const sortOrder = rowData['$sortOrder']
       const sortfield = rowData['$sortField']

       const resolution = rowData["resolution"];
       const practiceIssue = rowData['practiceIssue'];
       const source = rowData["source"]
       this.tryClearWhitespaceFromGlobalSearch(rowData);
       const globalSearchString = rowData["globalSearch"];
       const showMultiAdmins = rowData["showMultiAdmins"] || false;
       let url =  environment.apiUrl +
      "fetch/discrepancies?employeeName=" + employeeName +
      "&employeeId=" + employeeId +
      "&bedDev=" + bedDev +
      "&transactionStartDate=" + transactionStartDate +
      "&transactionEndDate=" + transactionEndDate +
      "&patientName=" + patientName +
      "&mrnNum=" + mrnNum +
      "&csn=" + csn +
      "&medDesc=" + medDesc +
      "&resolution=" + resolution +
      "&practiceIssue=" + practiceIssue +
      "&source=" + source +
      "&showMultiAdmins=" + showMultiAdmins +
      "&medGroup=" + medGroup +
      "&serviceGroup=" + serviceGroup +
      "&$skip=" + skip +
      "&$sortField=" + sortfield +
      "&$sortOrder=" + sortOrder
      if (globalSearchString)
      {
        url += "&globalSearch="+
        globalSearchString;
      }

      if (riskLevel != null){
        url = url +"&riskLevel=" + riskLevel;
      }

      if(regionId && !regionId.includes("All") && regionId[0]){
        url = url + "&regionId=" + regionId
      }

      if (campusId && !campusId.includes("All") && campusId[0]){
        url = url +"&campusId=" + campusId;
      }

      if (facilityId && !facilityId.includes("All") && facilityId[0]){
        url = url +"&facilityId=" + facilityId;
      }

      if(rowData["parent"]==true || rowData["subParent"]== true)
      {
        url = url+"&locationGrouping="+rowData["locationGroupingString"]
      }
      if(rowData['pageType']){
        url = url+"&pageType=" + rowData['pageType']
      }
      if(rowData['duration']){
        url = url+"&duration=" + rowData['duration'].toString()
      }
      if(rowData['wasteRecordType']){
        url = url + "&wasteRecordType=" + rowData['wasteRecordType']
      }
      if(rowData['adminType']){
        url = url + "&adminType=" + rowData['adminType']
      }
      if(rowData['noDiscrepancies']){
        url = url + "&noDiscrepancies=" + rowData['noDiscrepancies']
      }
      if(rowData['maapRiskRecommended']){
        url = url + "&maapRiskRecommended=" + rowData['maapRiskRecommended']
      }

    return this.http.get(
      url
     );
  }
}
